import { lazy } from "react"

export const LimitsAnalyticsPage = lazy(() => import("./LimitsAnalyticsPage"))